var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#D8ECFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6904 52.0026C43.776 52.0026 52.7626 43.0477 52.7626 32.0013C52.7626 20.9549 43.776 12 32.6904 12C21.6048 12 12.6182 20.9549 12.6182 32.0013C12.6182 43.0477 21.6048 52.0026 32.6904 52.0026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7094 16.6167H11.2906C9.53094 16.6167 8.10449 18.0381 8.10449 19.7915V45.3911C8.10449 47.1445 9.53094 48.5659 11.2906 48.5659H52.7094C54.469 48.5659 55.8955 47.1445 55.8955 45.3911V19.7915C55.8955 18.0381 54.469 16.6167 52.7094 16.6167Z",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4324 37.5386C37.2672 37.5386 42.1021 37.5386 46.9396 37.5386C48.1423 37.5386 48.9202 38.5387 48.5379 39.5864C48.3149 40.2028 47.8529 40.5415 47.2024 40.6155C47.059 40.6314 46.913 40.6235 46.767 40.6235C37.1769 40.6235 27.5869 40.6235 17.9968 40.6235C17.7738 40.6235 17.5402 40.6261 17.3251 40.5758C16.5631 40.3959 16.0666 39.6843 16.1436 38.9223C16.2206 38.163 16.8498 37.5704 17.6357 37.5439C18.103 37.528 18.5703 37.5386 19.0376 37.5386C23.5034 37.5386 27.9666 37.5386 32.4324 37.5386Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3633 30.205C15.3686 27.435 17.6413 25.1888 20.4265 25.2047C23.1851 25.2205 25.4259 27.4694 25.4206 30.2262C25.4153 32.9962 23.1426 35.245 20.3601 35.2291C17.6015 35.2133 15.3606 32.9592 15.3659 30.2076L15.3633 30.205ZM20.3734 32.1416C21.4354 32.1522 22.3142 31.2924 22.3248 30.2341C22.3328 29.1732 21.4726 28.3001 20.4105 28.2895C19.3459 28.2816 18.4697 29.1362 18.4591 30.1971C18.4485 31.258 19.3087 32.1311 20.3707 32.1416H20.3734Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5738 25.2021C41.3776 25.2021 44.184 25.1968 46.9877 25.2021C48.1665 25.2047 48.9418 26.2603 48.5223 27.2948C48.2701 27.9192 47.7842 28.2605 47.1072 28.2816C46.5443 28.3001 45.9788 28.2869 45.4159 28.2869C40.4032 28.2869 35.3904 28.2869 30.3777 28.2869C30.1547 28.2869 29.921 28.2896 29.7059 28.2393C28.9439 28.0594 28.4475 27.3477 28.5245 26.5857C28.6041 25.792 29.2599 25.2073 30.1148 25.2047C32.6292 25.1968 35.1435 25.2021 37.6578 25.2021C37.9632 25.2021 38.2712 25.2021 38.5765 25.2021H38.5738Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5769 34.4565C35.7732 34.4565 32.9668 34.4592 30.163 34.4565C29.2338 34.4565 28.5488 33.8295 28.5169 32.9802C28.4824 32.1151 29.1462 31.4061 30.0329 31.377C30.5321 31.3611 31.0312 31.3743 31.5331 31.3743C36.6759 31.3743 41.8161 31.3743 46.9589 31.3743C48.167 31.3743 48.9449 32.4352 48.5228 33.4856C48.2758 34.102 47.7103 34.4565 46.943 34.4565C44.1552 34.4565 41.3674 34.4565 38.5769 34.4565Z",
    fill: "#0561FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 40,
    fill: "white",
    transform: "translate(7 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.4b91a625efe59fef5988de8e24985610.svg";
export { ForwardRef as ReactComponent };